import React, { useEffect } from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

import GroupsTabPane from './groups/GroupsTabPane';
import SimpleNavigationBar from '../navigation/SimpleNavigationBar';

const StyledAuthorizationView = styled.div`
  height: calc(100% - 63px);
  overflow-y: auto;

  .authorization-view-wrapper {
    display: flex;
    flex-direction: column;
    padding: 20px;

    & > .authorization-view-header-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }
  }
`;

const AuthorizationView = ({ fetchingGroups, updatingGroup, deleting, fetchGroups }) => {
  useEffect(() => {
    fetchGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SimpleNavigationBar />
      <StyledAuthorizationView>
        <Spin spinning={fetchingGroups || updatingGroup || deleting} size="large">
          <div className="authorization-view-wrapper">
            <div className="authorization-view-header-wrapper">
              <h2 style={{ margin: 0 }}>Authorization</h2>
            </div>
            <GroupsTabPane />
          </div>
        </Spin>
      </StyledAuthorizationView>
    </>
  );
};

export default AuthorizationView;
